import { Container, SectionNewsletterPromocoes } from './styles'
import { FaSpinner } from 'react-icons/fa'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { validationFields } from '../../util/validationSchemas'
import * as yup from 'yup'
import { useBlackFriday } from 'src/contexto/hooks/useBlackFriday'

export default function NewsletterSection({
  background = false,
  className = '',
  initialColor,
  finalColor,
  textColor,
  buttonColor,
}) {
  const [newsletter, setNewsletter] = useState({ nome: '', email: '' })
  const [loading, setLoading] = useState(false)
  const newsletterValidationSchema = yup.object().shape({
    nome: validationFields.nome,
    email: validationFields.email,
  })
  const { isBlackFridayTheme } = useBlackFriday()

  function sendNewsletterToastError(message) {
    return sendNewsletterToast('error', message)
  }

  function sendNewsletterToastSuccess(message) {
    return sendNewsletterToast('success', message)
  }

  function sendNewsletterToast(type, message) {
    const newsletterToastOptions = {
      toastId: 'NewsletterToast',
    }
    switch (type) {
      case 'error':
        return toast.error(message, newsletterToastOptions)
      case 'success':
        return toast.success(message, newsletterToastOptions)
    }
  }

  async function isValidNewsletter(newsletter) {
    for (const field in newsletter) {
      if (!newsletter[field] || newsletter[field] === '') {
        sendNewsletterToastError(`Campo ${field} de preenchimento obrigatório`)
        return false
      }
    }
    const validatedData = await newsletterValidationSchema
      .validate(newsletter)
      .catch((err) => {
        err.errors.map((mensage) => {
          sendNewsletterToastError(mensage)
        })
        return false
      })

    return validatedData
  }

  async function assinarNewsletter(e) {
    e.preventDefault()
    toast.dismiss()

    const validatedData = await isValidNewsletter(newsletter)
    if (!validatedData) {
      return false
    }
    setLoading(true)

    const response = await fetch(
      `${process.env.REACT_APP_API_URI}/canais/newsletter/inscricao`,
      {
        method: 'POST',
        headers: {
          canal: 'gazin-ecommerce',
          'Content-Type': 'application/json;charset=utf-8',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
        },
        body: JSON.stringify(validatedData),
      }
    )
    setLoading(false)

    if (!response.ok) {
      response
        .json()
        .then((data) => data.map((erro) => sendNewsletterToastError(erro)))
      return false
    }
    sendNewsletterToastSuccess('Cadastro realizado com sucesso!')
    return true
  }
  return (
    <SectionNewsletterPromocoes
      darkTheme={isBlackFridayTheme}
      className={className}
      initialColor={initialColor}
      finalColor={finalColor}
      textColor={textColor}
      buttonColor={buttonColor}
    >
      <Container>
        <div className="texto">
          <h2>Aproveite nossas promoções!</h2>
          <p>Cadastre seu e-mail e receba ofertas exclusivas</p>
        </div>
        <form onSubmit={(e) => assinarNewsletter(e)}>
          <input
            type="text"
            placeholder="Digite seu nome"
            value={newsletter.nome}
            required
            onChange={(e) =>
              setNewsletter({ ...newsletter, nome: e.target.value })
            }
          />
          <input
            type="text"
            placeholder="Digite seu e-mail"
            value={newsletter.email}
            required
            onChange={(e) =>
              setNewsletter({ ...newsletter, email: e.target.value })
            }
          />
          <button type="submit" onClick={(e) => assinarNewsletter(e)}>
            {loading ? <FaSpinner color="#FFF" size="20" /> : 'quero receber'}
          </button>
        </form>
      </Container>
    </SectionNewsletterPromocoes>
  )
}
